import { useState, useEffect } from 'react';

/**
 * 특정 시간으로부터 경과 시간을 계산하는 훅
 * @param lastRewardedAt 마지막 보상 받은 시간 (ISO8601 문자열)
 * @param minutes 경과해야 하는 시간(분)
 * @returns 남은 시간을 "MM:SS" 형식으로 반환, null이면 null 반환
 */
export const useCountdownMinutes = (
  lastRewardedAt: string | null | undefined,
  minutes: number
): string | null => {
  const [countdown, setCountdown] = useState<string | null>(null);

  useEffect(() => {
    if (!lastRewardedAt) {
      setCountdown(null);
      return;
    }

    const updateCountdown = () => {
      const lastRewarded = new Date(lastRewardedAt);
      const now = new Date();

      // 마지막 보상 시간으로부터 지정된 시간(분) 후 계산
      const nextReward = new Date(lastRewarded);
      nextReward.setMinutes(nextReward.getMinutes() + minutes);

      const diff = nextReward.getTime() - now.getTime();

      if (diff <= 0) {
        // 이미 지났으면 null 반환 (보상 가능 상태)
        setCountdown(null);
        return;
      }

      // 분, 초 계산
      const remainingMinutes = Math.floor(diff / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);

      setCountdown(
        `${String(remainingMinutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`
      );
    };

    // 즉시 한 번 실행
    updateCountdown();

    // 1초마다 업데이트
    const interval = setInterval(updateCountdown, 1000);

    return () => clearInterval(interval);
  }, [lastRewardedAt, minutes]);

  return countdown;
};
